export default /* glsl */`
#include <morphtarget_pars_vertex>

varying vec3 vWorldDirection;
varying vec3 vWorldPosition;
uniform float uv_rotation;

#include <common>
void main() {
	#include <begin_vertex>
	
	vWorldPosition = position;
	
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <project_vertex>
}
`;